import React from 'react'

import { Box, makeStyles, Typography } from '@material-ui/core'
import { colors } from 'theme'
import PaperPlaneIcon from './PaperPlaneIcon'

const UpgradeYourPlanMenuItem = () => {
  const classes = useStyles()
  return (
    <Box container className={classes.menuItem}>
      <PaperPlaneIcon />
      <Typography className={classes.fakeLink}>Upgrade Your Plan</Typography>
    </Box>
  )
}

const useStyles = makeStyles(theme => ({
  fakeLink: {
    color: colors.white,
    fontSize: 12,
    fontWeight: 500,
    textDecoration: 'underline',
    textTransform: 'uppercase',

    '&:hover, &:active': {
      color: colors.white,
    },
  },
  menuItem: {
    backgroundColor: colors.blueGray100,
    padding: theme.spacing(1.5, 2),
    minWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    borderRadius: 5,
    gap: `${theme.spacing(1)}px`,
  },
}))

export default UpgradeYourPlanMenuItem
